import { render } from "./DisplayImageDetails.vue?vue&type=template&id=6d26e8be&scoped=true"
import script from "./DisplayImageDetails.vue?vue&type=script&lang=js"
export * from "./DisplayImageDetails.vue?vue&type=script&lang=js"

import "./DisplayImageDetails.vue?vue&type=style&index=0&id=6d26e8be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d26e8be"]])

export default __exports__